<template>
     <v-card>
        <v-layout>
            <v-card-title class="headline">
                <strong class="headline deep-purple--text">Editar potencial</strong> 
            </v-card-title>
        </v-layout>
        <v-divider class="deep-purple"/>  
        <v-layout row wrap class="mx-4 mt-3">        
            <v-flex xs12 md6>
                <v-sheet color="deep-purple darken-3" height="60" elevation="3" dark> 
                    <blockquote class="blockquote">   
                        <h3 class="text-truncate"> {{ edicao.creditor }} </h3>
                    </blockquote>
                </v-sheet>
            </v-flex>
            <v-flex xs12 sm12>
                <v-checkbox  class="mx-1 mt-5" label="Ativo" v-model="edicao.active" color="deep-purple"/>  
            </v-flex>                          
            <v-flex sm10 md4>
                <v-text-field class="mx-1" type="number" step="1" label="Mínimo de dias de atraso" box v-model="edicao.min_days_of_delay"/>                
            </v-flex>  
            <v-flex sm10 md4>
                <v-text-field class="mx-1" type="number" step="1" label="Máximo de dias de atraso" box v-model="edicao.max_days_of_delay" :disabled="is_null_max_days_of_delay"/>                
            </v-flex>
            <v-flex sm10 md4>
                <v-text-field class="mx-1" type="number" step="0.01" label="Potencial de ganho" hint="decimal (0,00)" box v-model="edicao.fee"/>                
            </v-flex>    
            <v-checkbox class="mx-1" v-model="is_null_max_days_of_delay" label="Sem máximo de dias de atraso" color="deep-purple"  @change="altera_max_days_of_delay"/>                       
        </v-layout>
        <v-divider class="deep-purple"/>
        <v-card-actions class="py-2">
            <v-btn flat color="primary" @click="fechar_modal">Cancelar</v-btn>  
            <v-spacer></v-spacer>
            <v-btn color="deep-purple" dark @click="salvar" :disabled="esperar">Salvar</v-btn>     
        </v-card-actions>
    </v-card>    
</template>

<script>
export default {
    props:['item_edicao', 'esperar'],
    data(){
        return{
           edicao:{
               min_days_of_delay:0,
               max_days_of_delay:0,
               fee:0.0,
               active:true,
               creditor:''
           },
           is_null_max_days_of_delay:false
        }
    },
    watch:{
        item_edicao: function(novo, antigo){
            this.edicao = {
                min_days_of_delay: novo.min_days_of_delay,
                max_days_of_delay: novo.max_days_of_delay,
                fee: novo.fee,
                active: novo.active,
                creditor: novo.creditor.name
            }
            if( this.edicao.max_days_of_delay  === null){
                this.is_null_max_days_of_delay = true
            } else {
                this.is_null_max_days_of_delay = false
            }
        }
    },
    methods:{
        fechar_modal(){
            this.$emit('fechar')
        },
        salvar(){
            this.$emit('salvar', this.edicao)
        },
        altera_max_days_of_delay(){
            if (this.edicao.max_days_of_delay === null) {
                this.edicao.max_days_of_delay = 0
                this.is_null_max_days_of_delay = false
            } else {
                this.edicao.max_days_of_delay = null
                this.is_null_max_days_of_delay = true
            }
        }
    }
}
</script>